export default {
  'motlet.set.xaxis.points': {
    ko: 'X축 표시범위 설정',
    ja: 'X軸の表示範囲を設定',
    en: 'Set the range of X-axis',
    cn: '',
  },
  'motlet.settings.chart.item': {
    ko: '차트 항목 선택',
    ja: 'チャート項目を選択',
    en: 'Select chart item',
    cn: '',
  },
  // BEGIN::Added.by.SHJ.2026.04.22.
  'motlet.settings.memoryType': {
    ko: 'Memory Type',
    ja: 'メモリタイプ',
    en: 'Memory Type',
    cn: '',
  },
  'motlet.settings.chartType': {
    ko: 'Chart Type',
    ja: 'チャートタイプ',
    en: 'Chart Type',
    cn: '',
  },
  'motlet.settings.bufferType': {
    ko: 'Buffer Type',
    ja: 'バッファタイプ',
    en: 'Buffer Type',
    cn: '',
  },
  // FINISH::Added.by.SHJ.2026.04.22.
  // BEGIN::Added.by.SHJ.2026.04.28.
  'motlet.settings.fsysType': {
    ko: 'File System',
    ja: 'ファイルシステム',
    en: 'File System',
    cn: '',
  },
  // FINISH::Added.by.SHJ.2026.04.28.
  'motlet.abap.dump.term.set': {
    ko: 'ABAP Dump 누계 시간 설정',
    ja: 'ABAPダンプの累計時間を設定',
    en: 'Set the cumulative duration for ABAP Dump',
    cn: '',
  },
  'motlet.taskType': {
    ko: 'Task Type',
    ja: 'タスクタイプ',
    en: 'Task Type',
    cn: '',
  },
  'motlet.logonType': {
    ko: 'Logon Type',
    ja: 'ログオンタイプ',
    en: 'Logon Type',
    cn: '',
  },
  'motlet.abap.dump.term': {
    ko: 'ABAP Dump',
    ja: 'ABAPダンプ',
    en: 'ABAP Dump',
    cn: '',
  },
  'motlet.loadKind': {
    ko: 'Load Kind',
    ja: 'ロード種類',
    en: 'Load Kind',
    cn: '',
  },
  'motlet.info.yaxis.than.100': {
    ko: 'Y축의 최대값이 100보다 작을 수 없습니다.',
    ja: 'Y軸の最大値は100未満にできません。',
    en: 'Y Axis max value is not able to be loweer than 100',
    cn: '',
  },
  'motlet.upd.rec.term.set': {
    ko: 'Update Record 누계 시간 설정',
    ja: 'レコード更新の累計時間を設定',
    en: 'Set the cumulative duration for Update Record',
    cn: '',
  },
  'motlet.wpType': {
    ko: 'WP Type',
    ja: 'WPタイプ',
    en: 'WP Type',
    cn: '',
  },
  'motlet.plus.yaxis': {
    ko: '100 더하기',
    ja: '+100',
    en: 'Plus 100',
    cn: '',
  },
  'motlet.settings.grid.column': {
    ko: '그리드 컬럼 선택',
    ja: 'グリッド列を選択',
    en: 'Select grid column',
    cn: '',
  },
  'motlet.yAxisMax': {
    ko: 'Y Axis Max Value',
    ja: 'Y軸の最大値',
    en: 'Y Axis Max Value',
    cn: '',
  },
  'motlet.taskType.checkAll': {
    ko: '전체',
    ja: '全体',
    en: 'All Task Type',
    cn: '',
  },
  'motlet.upd.rec.term': {
    ko: 'Update Record',
    ja: 'レコード更新',
    en: 'Update Record',
    cn: '',
  },
  'dv.info.xaxis.gt.360': {
    ko: 'X축 포인트의 최대값이 360보다 클 수 없습니다.',
    ja: 'X軸ポイントの最大値が360を超えることはできません。',
    en: 'Max value of range of X-Axis is not able to be greater than 360',
    cn: '',
  },
  'motlet.minus.yaxis': {
    ko: '100 빼기',
    ja: '-100',
    en: 'Minus 100',
    cn: '',
  },
  'dv.info.xaxis.lt.30': {
    ko: 'X축 표시범위의 최소값이 30보다 적을 수 없습니다.',
    ja: 'X軸の表示範囲の最小値は30より小さくできません。',
    en: 'Min value of range of X-Axis is not able to be less than 30',
    cn: '',
  },
};
